export function FrontPage() {
  const someVar = 'Do something here!';

  const init = () => {
    console.log(
      `%c You're on the front page - ` + someVar,
      'background-color: lightblue; color: black; display: block; line-height: 35px;',
    );
  };

  return { init };
}
